import { render } from "./App.vue?vue&type=template&id=45fccc8f"
const script = {}

import "./App.vue?vue&type=style&index=0&id=45fccc8f&lang=scss"

import exportComponent from "D:\\现有所有项目\\working-hours\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__